import "./WhoWeServe.module.css";
import Header from "@/reusable_sections/Header";
import DomesticAirConditioningHero from "./sections/DomesticAirConditioningHero";
import Installation from "./sections/Installation";
import Services from "./sections/Services";
import DomesticSpacesShowcase from "./sections/DomesticSpacesShowcase";
import Maintenance from "./sections/Maintenance";
import Emergency from "./sections/Emergency";
import Installationfaq from "./sections/Installationfaq";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function WhoWeServePage() {
  return <div>
      <Header />
      <DomesticAirConditioningHero />
      <Installation />
      <Services />
      <DomesticSpacesShowcase />
      <Maintenance />
      <Emergency />
      <Installationfaq />
      <Consultation />
      <Footer />
    </div>;
}